import { IoClose } from "react-icons/io5";
import { Link } from "react-router-dom";

const SIZE_CLASSES = {
	sm: "px-2 py-0.5 text-xs",
	md: "px-3 py-1 text-xs",
};

const HOVER_CLASSES = "transition-colors hover:bg-opacity-10";

/**
 * Shared teal tag chip used on catalog cards, book detail, and admin tables.
 */
const TagChip = ({
	name,
	as = "span",
	to,
	onClick,
	onRemove,
	size = "md",
	className = "",
	title,
}) => {
	const sizeClass = SIZE_CLASSES[size] || SIZE_CLASSES.md;
	const classes = `inline-flex max-w-full items-center gap-1 rounded-full border border-akgreener border-opacity-20 bg-akgreener bg-opacity-5 font-semibold text-akgreenest ${sizeClass} ${className}`;
	const label = title || name;

	const content = (
		<>
			<span className="truncate">{name}</span>
			{onRemove && (
				<button
					type="button"
					onClick={(event) => {
						event.preventDefault();
						event.stopPropagation();
						onRemove(name);
					}}
					aria-label={`Remove ${name}`}
					className="inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-akgreenest text-opacity-70 hover:bg-akgreener hover:bg-opacity-10 hover:text-opacity-100"
				>
					<IoClose size={12} />
				</button>
			)}
		</>
	);

	if (as === "link" && to) {
		return (
			<Link
				to={to}
				onClick={onClick}
				title={label}
				className={`${classes} ${HOVER_CLASSES}`}
			>
				{content}
			</Link>
		);
	}

	if (as === "button") {
		return (
			<button
				type="button"
				onClick={onClick}
				title={label}
				className={`${classes} ${HOVER_CLASSES}`}
			>
				{content}
			</button>
		);
	}

	return (
		<span title={label} className={classes}>
			{content}
		</span>
	);
};

export default TagChip;
